import React from 'react';
import { useDroppable } from '@dnd-kit/core';

const DroppableCategory = ({ id, name, children }) => {
    const { setNodeRef, isOver } = useDroppable({ id });
    const isEmpty = React.Children.count(children) === 0;

    return (
        <div
            ref={setNodeRef}
            className={`rounded-md p-4 mb-2 transition-all duration-200 ${
                isEmpty ? 'min-h-[100px]' : ''
            } ${
                isOver ? 'bg-neutral-500/80 border-blue-400 shadow-lg' : 'bg-neutral-800'
            }`}
        >
            <div className="space-y-2">
                {children}
            </div>
        </div>
    );
};

export default DroppableCategory;
